import { saveAs } from 'file-saver'
import $http from '@/libs/axios'
import FormsHelper from '@/services/forms-service'

export default class InventorySupplierAPI {
  static async process(payload: any) {
    return (await $http.post('/inventory/suppliers', payload)).data
  }

  static async exportExcel(branchId: any, filters: any) {
    const url = `/inventory/suppliers/export/xlsx?${FormsHelper.prepareQueryString(filters, true)}`
    const file = (await $http.get(url, { responseType: 'blob' })).data
    saveAs(file, 'suppliers.xlsx')
  }

  static async delete(unitId: any) {
    return (await $http.delete(`/inventory/suppliers/${unitId}`)).data
  }

  static async list() {
    return (await $http.get('/inventory/suppliers')).data
  }

  static async getById(unitId: any) {
    return (await $http.get(`/inventory/suppliers/${unitId}`)).data
  }
}
